import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyCategoryRequestBody, PropertyCategoryResponse } from "./types";

export class PropertyCategoryAPI extends BaseAPI<
    PropertyCategoryRequestBody,
    PropertyCategoryResponse
> {
    protected route = ApiRoutes.property.category;
    protected method = RequestMethod.GET;
}
